import styled from "styled-components";

export const CardContainer = styled.div`
  background: ${({ theme }) => theme.colors.grey50};
  border-left: 2px solid ${({ theme }) => theme.colors.grey200};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  box-sizing: border-box;
  padding: 32px;
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const TextContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  li {
    margin-left: 24px;
  }
`;
